import { lazy } from "react";
import UserForm from "@/widgets/dashboard/users/UserForm";
import RouteGuard from "../routerPermission";

const UsersList = lazy(() =>
  import("@/pages/vendor/users").then((m) => ({ default: m.UsersListPage }))
);
const UserDetails = lazy(() =>
  import("@/pages/vendor/users").then((m) => ({ default: m.UserDetailsPage }))
);

const UserRoutes = {
  path: "members",
  children: [
    {
      path: "",
      element: (
        <RouteGuard resource="user" action="read">
          <UsersList />
        </RouteGuard>
      ),
    },
    {
      path: "create",
      element: (
        <RouteGuard resource="user" action="create">
          <UserForm />
        </RouteGuard>
      ),
    },
    {
      path: "edit/:UserId",
      element: (
        <RouteGuard resource="user" action="update">
          <UserForm />
        </RouteGuard>
      ),
    },
    {
      path: ":UserId",
      element: (
        <RouteGuard resource="user" action="read">
          <UserDetails />
        </RouteGuard>
      ),
    },
  ],
};

export default UserRoutes;
